(ns frontend.ui.page.fund.stop-reporting
  "The warning dialog of the fund page action \"Stop reporting permanently\".
   The layout follows ui.view.transaction-process.modals.transition.view."
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.ui.page.fund.core :as controller]
   [frontend.ui.page.fund.event :as event]
   [frontend.ui.page.fund.model :as model]
   [frontend.ui.page.fund.sub :as sub]
   [re-frame.core :as rf]
   [ui.components.alert.view :as alert]
   [ui.components.button.view :as button]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]))

(def confirmation-labels
  {:stop-new-reports :lp-stop-reporting-confirm-stop
   :archive-access   :lp-stop-reporting-confirm-archive-access
   :no-undo          :lp-stop-reporting-confirm-no-undo})

(defn confirmation-row
  [{:keys [fund-id confirmation checked?]}]
  [:label
   {:class "flex flex-row gap-2 items-start cursor-pointer"}
   [checkbox/view
    {:value     checked?
     :on-change (fn [value]
                  (rf/dispatch [::event/toggle-stop-reporting-confirmation
                                {:fund-id      fund-id
                                 :confirmation confirmation
                                 :checked?     value}]))}]
   [:span
    {:class "text-sm m-0 font-normal text-gray-700"}
    (loc/tr (get confirmation-labels confirmation))]])

(defn feeder-fund-note
  "The implications for a feeder fund. The master funds continue to report."
  [feeder-master-funds]
  (let [master-names (->> feeder-master-funds
                          (map :fund/name)
                          (string/join ", "))]
    [alert/warning {}
     [:p
      {:class "text-sm m-0 font-bold"}
      (loc/tr :lp-stop-reporting-feeder-of [master-names])]
     [:ul
      {:class "text-sm m-0 pl-4 mt-1 list-disc font-normal"}
      [:li (loc/tr :lp-stop-reporting-feeder-master-continues [master-names])]
      [:li (loc/tr :lp-stop-reporting-feeder-archive [master-names])]
      [:li (loc/tr :lp-stop-reporting-feeder-cannot-be-added)]]]))

(defn modal
  [{:keys [fund-id]}]
  (when-let [{:keys [confirmed all-confirmed?]}
             @(rf/subscribe [::sub/stop-reporting-dialog fund-id])]
    (let [close! #(rf/dispatch [::event/close-stop-reporting fund-id])
          {:keys [feeder-master-funds]} @(rf/subscribe [::sub/reporting fund-id])]
      [modal/view
       {:visible? true
        :hide!    close!}
       (loc/tr :lp-stop-reporting-permanently)
       [:div
        {:class "flex flex-col gap-4"}
        [alert/danger {}
         [:p
          {:class "text-sm m-0 font-bold"}
          (loc/tr :lp-stop-reporting-intro)]
         [:p
          {:class "text-sm m-0 mt-2 font-normal"}
          (loc/tr :lp-stop-reporting-after-this-action)]
         [:ul
          {:class "text-sm m-0 pl-4 mt-1 list-disc font-normal"}
          [:li (loc/tr :lp-stop-reporting-no-new-reports)]
          [:li (loc/tr :lp-stop-reporting-archive-access)]]]
        (when (seq feeder-master-funds)
          [feeder-fund-note feeder-master-funds])
        [:div
         {:class "flex flex-col gap-1"}
         [:p
          {:class "text-sm m-0 font-bold"}
          (loc/tr :lp-stop-reporting-important)]
         [:p
          {:class "text-sm m-0 font-normal"}
          (loc/tr :lp-stop-reporting-once-in-lifecycle)]
         [:p
          {:class "text-sm m-0 font-normal"}
          (loc/tr :lp-stop-reporting-cannot-be-reversed)]]
        [:div
         {:class "flex flex-col gap-2"}
         [:p
          {:class "text-sm m-0 font-bold"}
          (loc/tr :lp-stop-reporting-confirm-understanding)]
         (doall
          (for [confirmation model/stop-reporting-confirmations]
            ^{:key confirmation}
            [confirmation-row {:fund-id      fund-id
                               :confirmation confirmation
                               :checked?     (contains? confirmed confirmation)}]))]]
       [modal/footer-children-left-and-right
        [[button/secondary-hollow
          {:on-click close!}
          (loc/tr :cancel)]]
        [[button/danger-solid
          {:on-click  #(rf/dispatch [::controller/confirm-stop-reporting fund-id])
           :disabled? (not all-confirmed?)}
          (loc/tr :lp-stop-reporting-confirm-button)]]]])))
